import React from 'react';
import { Proposal, ProposalContentType } from '../../../core';
import { PropertyDetails } from '../../../core/api/models/project';
import RenderFloorPlanAndFurnishingDetails from './proposal-floor-plan-and-furnishing-detials';
import ProposalCommercialDetails from './proposal-commercial-details';
import ProposalAreaOffered from './proposal-area-offered';
import ProposalAmeneties from './proposal-ameneties';
import ProposalPropertyPhotos from './proposal-property-photos';
import ProposalOtherDetails from './proposal-other-details';
import ProposalOptionOverviewCardDetails from './proposal-option-overview-card-details';
import ProposalKeyDistancesCardDetails from './proposal-key-distances-card-details';
import ProposalKeyDetailsCard from './proposal-key-details-card';
import ProposalProposedCommercialsDetailsCard from './proposal-proposed-commercials-details-card';
import ProposalAreaOfferedcardDetails from './proposal-area-offered-card-details';

const publicUrl = window.location.origin; // process.env.PUBLIC_URL;
const logoIcon = `${publicUrl}/city-info-logo-pdf.png`;
const backgroundBgWithShadow = `${publicUrl}/background-bg-with-shadow.jpg`;
const mapPointerIcon = `${publicUrl}/map-pointer.svg`;

interface ProposalFormattedPropertiesDetailsProps {
    canEditCommercialDetails: any;
    enableEdit: boolean;
    formatProperties: (properties: any) => [any, ...any[]][];
    getAmenityIcon: (amenityName: string) => string;
    groupPropertiesByCommericialDetails: (properties: PropertyDetails[] | undefined) => any[];
    proposal: Proposal;
    proposedPropertyData: [any, React.Dispatch<any>][number];
    setIsEditProposedCommercials: React.Dispatch<React.SetStateAction<{ isOpen: boolean; data: any; propertiesForProject: PropertyDetails[]; }>>;
    splitFloorOffered: (groupedProperties: { floorOffered: number; totalBuiltArea: number; }[]) => { floorOffered: number; totalBuiltArea: number; }[][];
}

export function ProposalFormattedPropertiesDetails({ canEditCommercialDetails,
    enableEdit,
    formatProperties,
    getAmenityIcon,
    groupPropertiesByCommericialDetails,
    proposal,
    proposedPropertyData,
    setIsEditProposedCommercials,
    splitFloorOffered }: ProposalFormattedPropertiesDetailsProps) {
    return (
        <>
            {formatProperties(proposedPropertyData?.proposalProperties)?.map(
                (groupedProperties: any[], index: number) => {
                    const propertiesGroupedByCommericialDetails = groupPropertiesByCommericialDetails(groupedProperties)

                    const propertyData = groupedProperties[0];
                    if (proposal?.proposalContentType === ProposalContentType.Small || proposedPropertyData?.proposalDetails?.proposalContentType === ProposalContentType.Small) {
                        return (
                            <>
                                {/* short format start  */}
                                {/* option overview start */}
                                <table className="table-outer-area page-break"
                                    style={{
                                        // backgroundImage: `url(${require("../../../assets/images/proposal/background-bg-with-shadow.png")})`,
                                        backgroundImage: `url(${backgroundBgWithShadow})`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "bottom",
                                        backgroundSize: "cover",
                                        marginTop: "15px",
                                        minHeight: "794px",
                                    }}
                                    width="100%"
                                    cellPadding="10"
                                    cellSpacing="0"
                                >
                                    <tbody>
                                        <tr>
                                            <td align="right">
                                                <img
                                                    width={110}
                                                    src={logoIcon}
                                                    alt="property_image"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign="top" style={{ padding: "0" }}>
                                                <table cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td valign="top" width="31%">
                                                                <table
                                                                    width="100%"
                                                                    cellPadding="0"
                                                                    cellSpacing="0"
                                                                >
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>
                                                                                <table
                                                                                    cellPadding="0"
                                                                                    cellSpacing="0"
                                                                                    width="94%"
                                                                                >
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td
                                                                                                height="37"
                                                                                                style={{
                                                                                                    backgroundColor:
                                                                                                        "#EFEFEF",
                                                                                                    fontSize: "16px",
                                                                                                    padding: " 0 16px",
                                                                                                    textTransform:
                                                                                                        "uppercase",
                                                                                                    color: "#021D77",
                                                                                                }}
                                                                                            >
                                                                                                {" "}
                                                                                                O P T I O N {index + 1}
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                <div>
                                                                                    <img
                                                                                        style={{ width: "100%" }}
                                                                                        src={propertyData.projectImage}
                                                                                        alt="property_image"
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td align="right">
                                                                                <table
                                                                                    cellPadding="0"
                                                                                    cellSpacing="0"
                                                                                    style={{
                                                                                        position: "relative",
                                                                                        marginTop: "-37px",
                                                                                        maxWidth: '90%',
                                                                                    }}
                                                                                >
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td
                                                                                                height="37"
                                                                                                style={{
                                                                                                    backgroundColor: "#7EC5CF",
                                                                                                    fontSize: "16px",
                                                                                                    padding: " 0 16px",
                                                                                                    color: "#000",
                                                                                                }}
                                                                                            >
                                                                                                <table cellSpacing={0} cellPadding={3}>
                                                                                                    <tbody>
                                                                                                        <tr>
                                                                                                            <td valign="top" style={{ whiteSpace: 'nowrap' }}>
                                                                                                                <img
                                                                                                                    width={9}
                                                                                                                    height={18}
                                                                                                                    src={mapPointerIcon}
                                                                                                                    alt={propertyData?.location}
                                                                                                                    className="mr-2 position-relative"
                                                                                                                    style={{ top: "-1px" }}
                                                                                                                />
                                                                                                                Location:
                                                                                                            </td>
                                                                                                            <td valign="top">{propertyData?.location}</td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td
                                                                                // height="100"
                                                                                style={{
                                                                                    backgroundColor: "#021D77",
                                                                                    fontSize: "22px",
                                                                                    padding: "13px 16px",
                                                                                    color: "#fff",
                                                                                    fontWeight: 700,
                                                                                }}
                                                                            >
                                                                                <table
                                                                                    width="100%"
                                                                                    cellPadding="0"
                                                                                    cellSpacing="0"
                                                                                >
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td>
                                                                                                <b>
                                                                                                    {propertyData?.propertyName?.toUpperCase()}
                                                                                                </b>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td height="12"></td>
                                                                        </tr>
                                                                        {groupedProperties.length < 8 && 
                                                                            <ProposalAreaOfferedcardDetails
                                                                            groupedProperties={groupedProperties}
                                                                            />
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                            <td
                                                                width="69%"
                                                                valign="top"
                                                                style={{ padding: "0 33px", paddingTop: "5px", }}
                                                            >

                                                                <ProposalOptionOverviewCardDetails
                                                                    propertyData={propertyData}
                                                                />
                                                                {(propertyData?.commericialDetails?.length && propertiesGroupedByCommericialDetails?.length === 1) ?
                                                                    <ProposalProposedCommercialsDetailsCard
                                                                        canEditCommercialDetails={canEditCommercialDetails}
                                                                        enableEdit={enableEdit}
                                                                        groupedProperties={groupedProperties}
                                                                        propertyData={propertyData}
                                                                        setIsEditProposedCommercials={setIsEditProposedCommercials}
                                                                    // marginTop='30'
                                                                    // tableWidth='80%'
                                                                    />
                                                                    : ''}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td height="30"></td>
                                        </tr>
                                    </tbody>
                                </table>
                                {/* option overview end */}

                                {/* when commercial details have different values for different properties duplicate those and show in new pages start */}
                                <ProposalCommercialDetails
                                    canEditCommercialDetails={canEditCommercialDetails}
                                    enableEdit={enableEdit}
                                    groupedProperties={groupedProperties}
                                    index={index}
                                    propertyData={propertyData}
                                    setIsEditProposedCommercials={setIsEditProposedCommercials}
                                    propertiesGroupedByCommericialDetails={propertiesGroupedByCommericialDetails}
                                />
                                {/* when commercial details have different values for different properties duplicate those and show in new pages end*/}

                                {/* FLOOR & OFFICE AREA OFFERED long start */}
                                <ProposalAreaOffered
                                    groupedProperties={groupedProperties}
                                    index={index}
                                    propertyData={propertyData}
                                    splitFloorOffered={splitFloorOffered}
                                />
                                {/* FLOOR & OFFICE AREA OFFERED long  */}

                                <RenderFloorPlanAndFurnishingDetails properties={groupedProperties} index={index} showFurnishingDetails={((propertyData.typeOfFacility === "Pre Furnished" || propertyData.typeOfFacility === "Semi-Furnished") && propertyData.excludeFurnishingDetails === false)} />

                                {/* property photos start  */}
                                <ProposalPropertyPhotos
                                    index={index}
                                    propertyData={propertyData}
                                />
                                {/* property photos end */}

                                {/* short format end */}
                                {" "}
                            </>
                        );
                    } else if (
                        proposal?.proposalContentType === ProposalContentType.Medium || proposedPropertyData?.proposalDetails?.proposalContentType === ProposalContentType.Medium
                    ) {
                        return (
                            <>
                                {/* meduim format start  */}
                                {/* property details overview option 2 start  */}

                                {/* overview start  */}
                                <table className="table-outer-area page-break"
                                    style={{
                                        // backgroundImage: `url(${require("../../../assets/images/proposal/background-bg-with-shadow.png")})`,
                                        backgroundImage: `url(${backgroundBgWithShadow})`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "bottom",
                                        backgroundSize: "cover",
                                        marginTop: "15px",
                                        minHeight: "794px",
                                    }}
                                    width="100%"
                                    cellPadding="10"
                                    cellSpacing="0"
                                >
                                    <tbody>
                                        <tr>
                                            <td align="right">
                                                <img
                                                    width={110}
                                                    src={logoIcon}
                                                    alt="property image"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign="top" style={{ padding: "0" }}>
                                                <table cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td width="31%" valign="top">
                                                                <table
                                                                    width="100%"
                                                                    cellPadding="0"
                                                                    cellSpacing="0"
                                                                >
                                                                    <tbody>
                                                                        <tr>
                                                                            <td valign="top">
                                                                                <table
                                                                                    cellPadding="0"
                                                                                    cellSpacing="0"
                                                                                    width="94%"
                                                                                >
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td
                                                                                                height="37"
                                                                                                style={{
                                                                                                    backgroundColor:
                                                                                                        "#EFEFEF",
                                                                                                    fontSize: "16px",
                                                                                                    padding: " 0 16px",
                                                                                                    textTransform:
                                                                                                        "uppercase",
                                                                                                    color: "#021D77",
                                                                                                }}
                                                                                            >
                                                                                                {" "}
                                                                                                O P T I O N {index + 1}
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                <div>
                                                                                    <img
                                                                                        style={{ width: "100%" }}
                                                                                        src={propertyData.projectImage}
                                                                                        alt="property image"
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td align="right">
                                                                                <table
                                                                                    cellPadding="0"
                                                                                    cellSpacing="0"

                                                                                    style={{
                                                                                        position: "relative",
                                                                                        marginTop: "-37px",
                                                                                        maxWidth: "90%",
                                                                                    }}
                                                                                >
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td
                                                                                                height="37"
                                                                                                style={{
                                                                                                    backgroundColor: "#7EC5CF",
                                                                                                    padding: "0 16px",
                                                                                                    color: "#000",
                                                                                                }}
                                                                                            >

                                                                                                <table cellPadding="2"
                                                                                                    cellSpacing="0">
                                                                                                    <tbody>
                                                                                                        <tr>
                                                                                                            <td valign="top" style={{ whiteSpace: 'nowrap' }}>
                                                                                                                <img
                                                                                                                    width={9}
                                                                                                                    height={18}
                                                                                                                    src={mapPointerIcon}
                                                                                                                    alt={propertyData?.location}
                                                                                                                    className="mr-2"
                                                                                                                />
                                                                                                                Location:
                                                                                                            </td>
                                                                                                            <td valign="top">{propertyData?.location}</td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td
                                                                                // height="100"
                                                                                style={{
                                                                                    backgroundColor: "#021D77",
                                                                                    fontSize: "22px",
                                                                                    padding: "13px 16px",
                                                                                    color: "#fff",
                                                                                    fontWeight: 700,
                                                                                }}
                                                                            >
                                                                                <table
                                                                                    width="100%"
                                                                                    cellPadding="0"
                                                                                    cellSpacing="0"
                                                                                >
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td>
                                                                                                <b>
                                                                                                    {propertyData?.propertyName?.toUpperCase()}
                                                                                                </b>
                                                                                            </td>
                                                                                        </tr>
                                                                                        {/* <tr>
                                                <td height="8"></td>
                                              </tr> */}
                                                                                        <tr style={{ lineHeight: 0 }}>
                                                                                            <td>
                                                                                                <span
                                                                                                    style={{
                                                                                                        fontWeight: 400,
                                                                                                        fontSize: "14px",
                                                                                                        lineHeight: "19px"
                                                                                                    }}
                                                                                                >
                                                                                                    <em>
                                                                                                        By{" "}
                                                                                                        {propertyData?.developer}
                                                                                                    </em>
                                                                                                </span>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td height="12"></td>
                                                                        </tr>

                                                                        {groupedProperties.length < 8 && 
                                                                            <ProposalAreaOfferedcardDetails
                                                                            groupedProperties={groupedProperties}
                                                                            />
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                            <td
                                                                width="69%"
                                                                valign="top"
                                                                style={{
                                                                    padding: "0 33px",
                                                                    paddingTop: "5px",
                                                                }}
                                                            >
                                                                <ProposalOptionOverviewCardDetails
                                                                    propertyData={propertyData}
                                                                />

                                                                <ProposalKeyDetailsCard
                                                                    propertyData={propertyData}
                                                                />

                                                                <ProposalKeyDistancesCardDetails
                                                                    propertyData={propertyData}
                                                                />

                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td height="30"></td>
                                        </tr>
                                    </tbody>
                                </table>
                                {/* overview end  */}

                                {/* FLOOR & OFFICE AREA OFFERED long start */}
                                <ProposalAreaOffered
                                    groupedProperties={groupedProperties}
                                    index={index}
                                    propertyData={propertyData}
                                    splitFloorOffered={splitFloorOffered}
                                />
                                {/* FLOOR & OFFICE AREA OFFERED long  */}

                                {/* other details start  */}
                                <ProposalOtherDetails
                                    canEditCommercialDetails={canEditCommercialDetails}
                                    enableEdit={enableEdit}
                                    groupedProperties={groupedProperties}
                                    index={index}
                                    propertiesGroupedByCommericialDetails={propertiesGroupedByCommericialDetails}
                                    propertyData={propertyData}
                                    setIsEditProposedCommercials={setIsEditProposedCommercials}
                                />
                                {/* other details end */}

                                {/* when commercial details have different values for different properties duplicate those and show in new pages start */}
                                <ProposalCommercialDetails
                                    canEditCommercialDetails={canEditCommercialDetails}
                                    enableEdit={enableEdit}
                                    groupedProperties={groupedProperties}
                                    index={index}
                                    propertyData={propertyData}
                                    setIsEditProposedCommercials={setIsEditProposedCommercials}
                                    propertiesGroupedByCommericialDetails={propertiesGroupedByCommericialDetails}
                                />
                                {/* when commercial details have different values for different properties duplicate those and show in new pages end*/}

                                {/* ameneties start  */}
                                <ProposalAmeneties
                                    getAmenityIcon={getAmenityIcon}
                                    index={index}
                                    propertyData={propertyData}
                                />
                                {/* ameneties end */}

                                <RenderFloorPlanAndFurnishingDetails properties={groupedProperties} index={index} showFurnishingDetails={((propertyData.typeOfFacility === "Pre Furnished" || propertyData.typeOfFacility === "Semi-Furnished") && propertyData.excludeFurnishingDetails === false)} />

                                {/* property photos start  */}
                                <ProposalPropertyPhotos
                                    index={index}
                                    propertyData={propertyData}
                                />
                                {/* property photos end */}

                                {/* property details overview option 2 end  */}
                                {/* meduim format end */}
                            </>
                        );
                    } else {
                        return <></>;
                    }
                }
            )}
        </>
    );
}